export const SUBMIT_SURVEY_REQUEST = 'SUBMIT_SURVEY_REQUEST';
export const SUBMIT_SURVEY_SUCCESS = 'SUBMIT_SURVEY_SUCCESS';
export const SUBMIT_SURVEY_FAIL = 'SUBMIT_SURVEY_FAIL';
export const SUBMIT_SURVEY_RESET = 'SUBMIT_SURVEY_RESET';
